require("bootstrap");
import "../../stylesheets/sign_up_form";
import "../../stylesheets/components/forms";
import { format, validate } from 'rut.js'
import { formatPhoneNumber, loadPhoneNumber } from "../backoffice/utils";
import { updateSubcategorySelectOptions } from "../utils";
import "select2";
import "select2/dist/css/select2.css";

$(document).ready(function () {
  /* Initial Configuration */
  const progress_bar_bullets = document.querySelectorAll(".step .bullet");
  const progress_bar_texts = document.querySelectorAll(".step p");
  const outer_form = document.querySelector(".outer-form");
  let current_step = 1
  progress_bar_bullets[current_step - 1].classList.add("active");
  progress_bar_texts[current_step - 1].classList.add("active");
  const form = $("#new_user");
  let person_type = 'legal'
  let tax_type = 'rut'
  loadPhoneNumber();
  updateSubcategorySelectOptions();
  // const chooseFile = document.getElementById("choose-file");
  // const imgPreview = document.getElementById("img-preview");

  $(".standard-select").select2({
    placeholder: "",
    allowClear: true,
  });

  function verifyPassword() {
    if (current_step == 2 && $("#password_field").val() != $("#confirm_password_field").val()) {
      $("#password-invalid-feedback").show()
      return false
    } else {
      $("#password-invalid-feedback").hide()
      return true
    }
  }

  $(".iti__country-list li").click(function () {
    $('#phone_number_hidden_input')[0].setAttribute(
      "data-code",
      $(this).data("dial-code")
    );
    formatPhoneNumber();
  });

  $("#user_account_attributes_country_id").change(function (e) {
    let tax_field = $('.tax-id-document')[0]
    if (this.value == '1') {
      $('#tax_id_label')[0].innerHTML = 'Rut Organización'
      tax_type = 'rut'
      validateRutAndUpdateUI();
    } else {
      $('#tax_id_label')[0].innerHTML = 'Documento de Identidad Organización'
      tax_type = 'other'
      $("#account_tax_id").removeClass("is-invalid");
      $("#account_tax_id").removeClass("is-valid");
      $('.send-first-step-leads').prop('disabled', false);
    }
  });

  $("#phone_number_hidden_input").change(function (e) {
    formatPhoneNumber();
  });

  $(".person-type-input").click(function () {
    person_type = this.value
  });
  const Fn = {
    // Valida el rut con su cadena completa "XXXXXXXX-X"
    formatRut: function (rut) {
      const pointless = rut.split(".").join("");
      const dashless = pointless.split("-").join("");
      return (
        dashless.substring(0, dashless.length - 1) +
        "-" +
        dashless.substring(dashless.length - 1, dashless.length)
      );
    },

    validaRut: function (rutField) {
      //if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
      var rutCompleto = rutField.value;
      if (rutField.value === "-") {
        rutField.value = "";
        rutCompleto = "";
      }
      const tmp = Fn.formatRut(rutCompleto).split("-");
      const rut = tmp[0];
      let digv = tmp[1];
      if (digv == "K") digv = "k";
      return Fn.dv(rut) == digv;
    },
    dv: function (T) {
      let M = 0,
        S = 1;
      for (; T; T = Math.floor(T / 10))
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : "k";
    },
  };
  lead_id
  $('#leads_from').change(function () {
    var selected = $('#leads_from').val();
    if (selected === 'other') {
      $('#leads_other_comment_form').show();
      $('#leads_other_comment').prop('required', true);
      $('#leads_foundation_recomendation_comment_form').hide();
      $('#leads_foundation_recomendation_comment').prop('required', false);
    } else if (selected === 'foundation_recommendation') {
      $('#leads_other_comment_form').hide();
      $('#leads_other_comment').prop('required', false);
      $('#leads_foundation_recomendation_comment_form').show();
      $('#leads_foundation_recomendation_comment').prop('required', true);
    } else {
      $('#leads_other_comment_form').hide();
      $('#leads_other_comment').prop('required', false);
      $('#leads_foundation_recomendation_comment_form').hide();
      $('#leads_foundation_recomendation_comment').prop('required', false);
      $('#leads_comment').val('');
    }
  });

  $('#leads_other_comment').change(function () {
    $('#leads_comment').val($('#leads_other_comment').val())
  });

  $('#leads_foundation_recomendation_comment').change(function () {
    $('#leads_comment').val($('#leads_foundation_recomendation_comment').val())
  });


  $("#conditions").change(function () {
    this.checked ? $('#conditions-invalid-feedback').hide() : $('#conditions-invalid-feedback').show()
  })

  $("#user-data").change(function () {
    this.checked ? $('#user-data-invalid-feedback').hide() : $('#user-data-invalid-feedback').show()
  })

  $('#open-conditions').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('#conditions-modal').modal('show')
  });

  /* Handle Move To  Next Step */
  $(".next-step").click(({ target }) => {
    form[0].classList.add("was-validated");
    event.preventDefault();
    event.stopPropagation();
    const type = person_type;
    if (form[0].checkValidity() === true) {
      Array.from(document.querySelectorAll(`#step-${current_step} .form-control`)).map(input => {
        input.removeAttribute("required");
      })
      Array.from(document.querySelectorAll(`#step-${current_step + 1} .form-control`)).map(input => {
        input.getAttribute("data_type") == 'social-media' ? null : input.setAttribute("required", true);
      })
      type ? (type == "natural" ? ($("#business_input").hide() && $("#business_input input").attr("required", false)) : ($("#business_input").show() && $("#business_input input").attr("required", true))) : null;
      type ? (type == "natural" ? $("#user-name-label").text("Nombre Plataforma") : $("#user-name-label").text("Nombre Organización")) : null;
      type ? (type == "natural" ? $("#user_account_attributes_contact_email").val($("#user_email")[0].value) : null) : null;
      $('#leads_other_comment').prop('required', false);
      $('#leads_foundation_recomendation_comment').prop('required', false);
      progress_bar_bullets[current_step - 1].classList.remove("active");
      progress_bar_texts[current_step - 1].classList.remove("active");
      progress_bar_bullets[current_step].classList.add("active");
      progress_bar_texts[current_step].classList.add("active");
      outer_form.style.marginLeft = "-" + 100 * current_step + "%";
      form[0].classList.remove("was-validated");
      current_step += 1;
    }
  });

  /* Handle Move To Previous Step */
  $(".previous-step").click(({ target }) => {
    event.preventDefault();
    event.stopPropagation();
    current_step -= 1;
    Array.from(document.querySelectorAll(`#step-${current_step + 1} .form-control`)).map(input => {
      input.removeAttribute("required");
    })
    Array.from(document.querySelectorAll(`#step-${current_step} .form-control`)).map(input => {
      input.getAttribute("data_type") == 'social-media' ? null : input.setAttribute("required", true);
    })
    progress_bar_bullets[current_step].classList.remove("active");
    progress_bar_texts[current_step].classList.remove("active");
    progress_bar_bullets[current_step - 1].classList.add("active");
    progress_bar_texts[current_step - 1].classList.add("active");
    outer_form.style.marginLeft = "-" + 100 * (current_step - 1) + "%";
  });

  /* Submit new user and account form */
  $(".submit").click(({ target }) => {
    event.preventDefault();
    event.stopPropagation();
    grecaptcha.enterprise.ready(function () {
      grecaptcha.enterprise
        .execute(recaptcha_site_key, { action: "submit" })
        .then(function (token) {
          let captcha = $(`input[name="recaptcha_token"`);
          for (var i = 0; i < captcha.length; i++) {
            captcha[i].value = token;
          }
          form[0].classList.add("was-validated");
          $("#conditions")[0].checked ? $('#conditions-invalid-feedback').hide() : $('#conditions-invalid-feedback').show()
          $("#user-data")[0].checked ? $('#user-data-invalid-feedback').hide() : $('#user-data-invalid-feedback').show()
          if (form[0].checkValidity() === true && $("#conditions")[0].checked && $("#user-data")[0].checked && verifyPassword()) {
            form[0].submit()
          }
        });
    });
  });
  // Función para validar RUT y actualizar UI
  function validateRutAndUpdateUI() {
    let rutValidity = true;
    if (tax_type == 'rut') {
      const rutField = $("#account_tax_id")[0];
      rutValidity = rutField ? Fn.validaRut(rutField) : true;
      if (rutValidity === true) {
        const cleanRut = rutField.value.replace(/[^0-9kK]/g, '');
        const rutNumber = parseInt(cleanRut.slice(0, -1));
        const isInValidRange = rutNumber >= 50000000 && rutNumber <= 99999999;
        if (!isInValidRange) {
          rutValidity = false;
        }
      }
    }

    if (rutValidity === false) {
      $("#account_tax_id").addClass("is-invalid");
      $("#account_tax_id").removeClass("is-valid");
      $('.send-first-step-leads').prop('disabled', true);
    } else {
      $("#account_tax_id").addClass("is-valid");
      $("#account_tax_id").removeClass("is-invalid");
      $('.send-first-step-leads').prop('disabled', false);
    }

    return rutValidity;
  }

  $("#account_tax_id").on('blur', ({ target }) => {
    validateRutAndUpdateUI();
  });

  $("#account_tax_id").on('input', ({ target }) => {
    if (tax_type == 'other') {
      return
    }
    let val = format(target.value);
    target.value = val;
  });

  $("#user_account_attributes_layout").on('input', ({ target }) => {
    $("#subdomain")[0].innerHTML = $("#user_account_attributes_layout").val();
  });

  // First step save data
  $('.send-first-step-leads').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    grecaptcha.enterprise.ready(function () {
      grecaptcha.enterprise
        .execute(recaptcha_site_key, { action: "submit" })
        .then(function (token) {
          var first_step_params = {
            lead_id: $('#lead_id').html(),
            account_name: $("#user_account_attributes_name").val(),
            account_tax_id: $("#account_tax_id").val(),
            account_country_id: $("#user_account_attributes_country_id").val(),
            name: $("#user_name").val(),
            last_name: $("#user_last_name").val(),
            email: $("#user_email").val(),
            phone_number: $("#phone-number").val(),
            conditions_checked: $("#conditions")[0].checked,
            recaptcha_token: token
          }
          form[0].classList.add("was-validated");

          const rutValidity = validateRutAndUpdateUI();
          if (first_step_params && rutValidity === true) {
            $.ajax({
              type: 'POST',
              url: '/first_step_leads',
              data: first_step_params
            })
              .done(function (responseData) {
                $('#lead_id').text(responseData.data_id)
                if (responseData.existing_user === true) {
                  alert('¡Usuario ya existe! Presione aceptar para ir a recuperar contraseña')
                  window.location.href = '/users/password/new';
                }
                if (responseData.existing_account === true) {
                  alert('¡Cuenta con ese nombre ya existe! Ingresa un nombre diferente.')
                  window.location.href = '/users/sign_up';
                }

                if (responseData.existing_account_by_tax_id === true) {
                  alert('¡Ya existe una cuenta con ese rut! Ingresa un rut diferente.')
                  window.location.href = '/users/sign_up';
                }

                if (responseData.invalid_tax_id === true) {
                  alert('¡Rut inválido! Ingresa un rut válido de organización. Si crees que es un error, comunícate con ventas@donando.cl.')
                  window.location.href = '/users/sign_up';
                }
              })
          }
          else {
            alert('¡Rut inválido! Ingresa un rut válido de organización. Si crees que es un error, comunícate con ventas@donando.cl.')
            window.location.href = '/users/sign_up';
          }
        });
    });
  })

  // third step save data
  $('.send-second-step-leads').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    grecaptcha.enterprise.ready(function () {
      grecaptcha.enterprise
        .execute(recaptcha_site_key, { action: "submit" })
        .then(function (token) {
          var second_step_params = {
            lead_id: $('#lead_id').html(),
            account_address: $("#user_account_attributes_address").val(),
            account_business: $("#user_account_attributes_business").val(),
            account_layout: $("#user_account_attributes_layout").val(),
            from: $('#leads_from').val(),
            comment: $('#leads_comment').val(),
            conditions_checked: $("#conditions")[0].checked,
            data_checked: $("#user-data")[0].checked,
            recaptcha_token: token
          }
          if (second_step_params) {
            $.ajax({
              type: 'POST',
              url: '/second_step_leads',
              data: second_step_params
            })
              .done(function (responseData) {
                $('#lead_id').text(responseData.data_id)
              })
          }
        });
    });
  })
});
